import logo from 'assets/images/logo.png';

function Logo() {
    return <img src={logo} alt="Berry" width="140" />;
}

export default Logo;
